import { defineComponent as _defineComponent } from 'vue'
import { vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { style: {"width":"80px"} }
const _hoisted_2 = { style: {"width":"80px"} }
const _hoisted_3 = {
  key: 1,
  style: {"width":"80px"}
}

import SogPage from "@/shared/ui/SogPage.vue";
import SogCard from "@/shared/ui/SogCard.vue";
import SogCardContent from "@/shared/ui/SogCardContent.vue";
import VehicleRegistrationListComponent
  from "@/modules/VehicleRegistration/components/VehicleRegistrationListComponent.vue";
import {onMounted, reactive, ref, watch} from "vue";
import SogGrid from "@/shared/ui/SogGrid.vue";
import SogCardActions from "@/shared/ui/SogCardActions.vue";
import SogCardActionButton from "@/shared/ui/SogCardActionButton.vue";
import {SogButtonKind} from "@/shared/ui/types/SogButtonKind";
import SogTextBox from "@/shared/ui/SogTextBox.vue";
import SogDropDownList from "@/shared/ui/SogDropDownList.vue";
import SogCardActionDropDownButton from "@/shared/ui/SogCardActionDropDownButton.vue";
import SogDropDownButtonItem from "@/shared/ui/types/SogDropDownButtonItem";
import apiRegistrationInquiry from "@/modules/RegistrationInquiry/api";
import {registrationInquiryMailTypeItems} from "@/modules/RegistrationInquiry/mailTypeItems";
import notificationService from "@/shared/services/NotificationService";

import {useNavigationStore} from "@/modules/Navigation/store";
import {storeToRefs} from "pinia";
import {useAccountStore} from "@/stores/accountStore";
import {useVehicleRegistrationStore} from "@/modules/VehicleRegistration/store";
import {IdType} from "@/shared/model/idType";


export default /*@__PURE__*/_defineComponent({
  __name: 'VehicleRegistrationListPage',
  setup(__props) {

const _halterName = ref("");
const _lstYesNo = reactive([
  {id: "no", value: "Nein"},
  {id: "yes", value: "Ja"},
  {id: "all", value: "Alle"},
]);
const _fields = {text: "value", value: "id"};
const _listComponent = ref<InstanceType<typeof SogGrid> | null>(null);
const _vehicleStore = useVehicleRegistrationStore();
const {isRoot: _isRoot} = storeToRefs(useAccountStore());
const _navigationStore = useNavigationStore();
const _vehicleRegistrationId = ref<string | undefined>(undefined);
/** Markierte Zulassung ist unbekannt: nicht verknüpft und nicht ignoriert. */
const _isUnknownSelected = ref(false);
const {listPageFilter2: _listPageFilter2,listPageFilter: _listPageFilter} = storeToRefs(_vehicleStore);


/*const onRefresh = () => {
  _listComponent.value?.refresh()
}*/

function search(resetPage = true) {
  if (!_listComponent.value || !_listComponent.value.adaptor) return;
  _listComponent.value?.adaptor.removePredicate("number");
  if (_listPageFilter.value.number)
    _listComponent.value?.adaptor.addPredicate(
      "number",
      "contains",
      _listPageFilter.value.number.toUpperCase()
    );

  _listComponent.value?.adaptor.removePredicate("halterName");
  if (_halterName.value) {
    _listComponent.value?.adaptor.addPredicate(
      "halterName",
      "contains",
      _halterName.value.toUpperCase()
    );
  }

  _listComponent.value?.adaptor.removePredicate(
    "fahrzeugIdentifizierungsNummer"
  );
  if (_listPageFilter.value.FIN) {
    _listComponent.value?.adaptor.addPredicate(
      "fahrzeugIdentifizierungsNummer",
      "contains",
      _listPageFilter.value.FIN.toUpperCase()
    );
  }

  _listComponent.value?.adaptor.removePredicate("kennzeichen");
  if (_listPageFilter.value.kennzeichen) {
    _listComponent.value?.adaptor.addPredicate(
      "kennzeichen",
      "contains",
      _listPageFilter.value.kennzeichen.toUpperCase()
    );
  }

  _listComponent.value?.adaptor.removePredicate("insurance");
  if (_listPageFilter2.value.imBestand === "yes") {
    _listComponent.value?.adaptor.addPredicate("insurance", "equal", "yes");
  }
  if (_listPageFilter2.value.imBestand === "no") {
    _listComponent.value?.adaptor.addPredicate("insurance", "equal", "no");
  }

  _listComponent.value?.adaptor.removePredicate("ignore");
  if (_listPageFilter2.value.ignorierte === "yes") {
    _listComponent.value?.adaptor.addPredicate("ignore", "equal", "yes");
  }
  if (_listPageFilter2.value.ignorierte === "no") {
    _listComponent.value?.adaptor.addPredicate("ignore", "equal", "no");
  }

  _listComponent.value?.adaptor.removePredicate("suggestion");
  if (_listPageFilter2.value.vorschlag === "yes") {
    _listComponent.value?.adaptor.addPredicate("suggestion", "equal", "yes");
  }

  _listComponent.value.refresh(resetPage);
}

onMounted(() => {
  // gemerkte Filter anwenden, aber auf der gemerkten Seite bleiben
  search(false);
});

watch(_listPageFilter2.value, (value) => {
  if (value.imBestand === "yes" && _listPageFilter2.value.ignorierte === "yes") {
    _listPageFilter2.value.ignorierte = "all";
    return;
  }
  search();
});


function onSelected(value?: string, row?: { insuranceId?: string, ignore?: string }) {
  _navigationStore.currentVehicleRegistrationId = value;
  _vehicleRegistrationId.value = value;
  _isUnknownSelected.value = !!value && !row?.insuranceId && row?.ignore !== 'Y';
  /* _vRstore.vehicleRegistrationId = value
   console.log(_vRstore.vehicleRegistrationId)*/
}

async function onDetails() {
  if (_vehicleRegistrationId.value) {
    await _navigationStore.showObject(IdType.VehicleRegistration, _vehicleRegistrationId.value)
  }
}

async function onCreateInquiry(item?: SogDropDownButtonItem) {
  if (!item?.id || !_vehicleRegistrationId.value) {
    return
  }
  const t_id = await apiRegistrationInquiry.create(_vehicleRegistrationId.value, item.id)
  if (t_id) {
    notificationService.success("Entwurf wurde angelegt und liegt unter Recherche-Mails")
  }
}

function onSearch() {
  search();
}

function onUnknownSearch(){
  _listPageFilter2.value.ignorierte = "no";
  _listPageFilter2.value.imBestand = "no"
}

function onClear(){
  _listPageFilter.value.number = "";
  _listPageFilter.value.FIN = "";
  _listPageFilter.value.kennzeichen = "";
  _listPageFilter2.value.ignorierte = "all";
  _listPageFilter2.value.imBestand = "all";
  _listPageFilter2.value.vorschlag = "all";
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SogPage, { title: "Kfz-Zulassungen" }, {
    default: _withCtx(() => [
      _createVNode(SogCard, { title: "" }, {
        default: _withCtx(() => [
          _createVNode(SogCardActions, { "is-toolbar": true }, {
            default: _withCtx(() => [
              _withDirectives(_createVNode(SogCardActionButton, {
                "mdi-icon": "mdi-information",
                tooltip: "Details anzeigen",
                onClick: onDetails
              }, null, 512), [
                [_vShow, _vehicleRegistrationId.value]
              ]),
              (_unref(_isRoot))
                ? _withDirectives((_openBlock(), _createBlock(SogCardActionDropDownButton, {
                    key: 0,
                    "mdi-icon": "mdi-email-plus",
                    items: _unref(registrationInquiryMailTypeItems),
                    onSelect: onCreateInquiry
                  }, null, 8, ["items"])), [
                    [_vShow, _isUnknownSelected.value]
                  ])
                : _createCommentVNode("", true),
              _createVNode(SogTextBox, {
                modelValue: _unref(_listPageFilter).number,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(_listPageFilter).number) = $event)),
                placeholder: "eVB/VR-Nummer",
                "interval-modified": onSearch
              }, null, 8, ["modelValue"]),
              _createVNode(SogTextBox, {
                modelValue: _unref(_listPageFilter).kennzeichen,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(_listPageFilter).kennzeichen) = $event)),
                placeholder: "Kennzeichen",
                "interval-modified": onSearch
              }, null, 8, ["modelValue"]),
              _createVNode(SogTextBox, {
                modelValue: _unref(_listPageFilter).FIN,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(_listPageFilter).FIN) = $event)),
                placeholder: "Fahrzeug Id Nummer",
                "interval-modified": onSearch
              }, null, 8, ["modelValue"]),
              _createElementVNode("div", _hoisted_1, [
                _createVNode(SogDropDownList, {
                  modelValue: _unref(_listPageFilter2).imBestand,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(_listPageFilter2).imBestand) = $event)),
                  placeholder: "Im Bestand",
                  "data-source": _lstYesNo,
                  fields: _fields,
                  "popup-width": "80px"
                }, null, 8, ["modelValue", "data-source"])
              ]),
              _createElementVNode("div", _hoisted_2, [
                _createVNode(SogDropDownList, {
                  modelValue: _unref(_listPageFilter2).ignorierte,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(_listPageFilter2).ignorierte) = $event)),
                  placeholder: "Ignorierte",
                  "data-source": _lstYesNo,
                  fields: _fields,
                  "popup-width": "80px"
                }, null, 8, ["modelValue", "data-source"])
              ]),
              (_unref(_isRoot))
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createVNode(SogDropDownList, {
                      modelValue: _unref(_listPageFilter2).vorschlag,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(_listPageFilter2).vorschlag) = $event)),
                      placeholder: "Mit Vorschlag",
                      "data-source": _lstYesNo,
                      fields: _fields,
                      "popup-width": "80px"
                    }, null, 8, ["modelValue", "data-source"])
                  ]))
                : _createCommentVNode("", true),
              _createVNode(SogCardActionButton, {
                "mdi-icon": "mdi-car-search",
                tooltip: "Unbekante Zulassungen",
                onClick: onUnknownSearch
              }),
              _createVNode(SogCardActionButton, {
                kind: _unref(SogButtonKind).Search,
                onClick: onSearch
              }, null, 8, ["kind"]),
              _createVNode(SogCardActionButton, {
                kind: _unref(SogButtonKind).FilterRemove,
                onClick: onClear
              }, null, 8, ["kind"]),
              _createVNode(SogCardActionButton, {
                kind: _unref(SogButtonKind).Back
              }, null, 8, ["kind"])
            ]),
            _: 1
          }),
          _createVNode(SogCardContent, null, {
            default: _withCtx(() => [
              _createVNode(VehicleRegistrationListComponent, {
                ref_key: "_listComponent",
                ref: _listComponent,
                onSelected: onSelected
              }, null, 512)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})